import React from 'react'

import { IconProps } from '../../../../types'
import IconWrapper from '../../../IconWrapper'

const TrashIconSmall: React.FC<IconProps> = (props) => (
  <IconWrapper size="small" {...props}>
    <path d="M5.9 4.86h-1v8.41h1V4.86ZM8.5 4.86h-1v8.41h1V4.86ZM11.1 4.86h-1v8.41h1V4.86Z M14.69 2.63H10.5v-2h-5v2H1.31v1h1.12v10.38c0 .82.67 1.49 1.49 1.49h8.17c.82 0 1.49-.67 1.49-1.49V3.63h1.12v-1h-.01Zm-8.19-1h3v1h-3v-1Zm6.08 12.38c0 .27-.22.49-.49.49H3.91a.49.49 0 0 1-.49-.49V3.63h9.16v10.38Z" />
  </IconWrapper>
)

export default TrashIconSmall
